// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__account-select',
    // #endregion
    data: () => ({
        isLoading: false,
        accounts: []
    }),
    computed: {
        accountID() {
            return this.$host.store.get("session").currentUser?.accountID;
        },
    },
    beforeMount() {
        this.loadData();
    },
    // #region Core
    methods: {
        async loadData() {
            this.isLoading = true;
            try {
                this.accounts = (await host.api.get('identity/accounts')).data;
            }
            catch {
                this.accounts = [];
            }
            this.isLoading = false;
        },
        async onSelect(account) {
            if (!account) {
                return;
            }
            //Set
            await this.$host.login.setAccount(account.accountID);
            //Close
            this.$emit('close');
        },
        onclose() {
            this.$emit('close');
        }
    },
    // #endregion
});
// #endregion
